import SearchForm from './SearchForm.vue'
import SearchFilters from './SearchFilters.vue'
import SearchItemCard from './SearchItemCard.vue'
import DateRange from './DateRange.vue'

const SearchFormComponents = [SearchForm, SearchFilters, SearchItemCard, DateRange]

export default SearchFormComponents